// Validation for the Procurement Edit flow.
//
// In Procurement the first three tabs (Requirement / Supporting Document / DMUT)
// are read-only carry-overs from Planning, so the only editable inputs live on
// the Validity tab. "Save & Completed" validates those, then marks all four
// Overview steps Completed (per the agreed model), which is what enables Submit.

import { STEP, STEP_STATUS } from './procurementConstants';

// Validity tab: both date-times required, and neither may be a back-date
// (earlier than now). Validity Period must not be before the Submission
// Deadline. Returns an array of human-readable errors (empty = OK).
export const validateValidity = detail => {
  const v = detail.validity || {};
  const errors = [];
  const now = new Date();

  if (!v.submissionDeadline) {
    errors.push('Submission Deadline is required');
  } else if (new Date(v.submissionDeadline) < now) {
    errors.push('Submission Deadline cannot be a back date');
  }

  if (!v.validityPeriod) {
    errors.push('Validity Period is required');
  } else if (new Date(v.validityPeriod) < now) {
    errors.push('Validity Period cannot be a back date');
  }

  if (
    v.submissionDeadline &&
    v.validityPeriod &&
    new Date(v.validityPeriod) < new Date(v.submissionDeadline)
  ) {
    errors.push('Validity Period cannot be earlier than Submission Deadline');
  }

  return errors;
};

// All four Overview steps marked Completed — used by "Save & Completed".
export const allStepsCompleted = () => ({
  [STEP.REQUIREMENT]: STEP_STATUS.COMPLETED,
  [STEP.SUPPORTING_DOCUMENT]: STEP_STATUS.COMPLETED,
  [STEP.DMUT]: STEP_STATUS.COMPLETED,
  [STEP.VALIDITY]: STEP_STATUS.COMPLETED,
});

// True when every step is Completed (gates the Submit button).
export const isAllCompleted = steps =>
  !!steps && Object.values(STEP).every(k => steps[k] === STEP_STATUS.COMPLETED);
